import axios from "axios";
import { GOOGLE_MAPS_API_KEY } from "../config/env";

const getLatLng = async (values) => {
  const address = encodeURIComponent(
    [values.address, values.state, values.country].filter(Boolean).join(", "),
  );
  const api = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GOOGLE_MAPS_API_KEY}`;
  const result = await axios.get(api);
  const { status, results, error_message: errorMessage } = result.data;

  if (status !== "OK" || !results?.[0]?.geometry?.location) {
    throw new Error(
      errorMessage ||
        (status === "ZERO_RESULTS"
          ? "No location was found for the designer address"
          : "Unable to retrieve the designer location"),
    );
  }

  const { lat, lng } = results[0].geometry.location;
  return `${lat},${lng}`;
};

export default getLatLng;
